import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { FilterMatchMode } from "primereact/api";
import { MultiSelect } from "primereact/multiselect";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';
import { Checkbox } from "primereact/checkbox";
import { taxPageRows, taxRowsPerPageOptions } from "./common/envTax";
import { fetchTaxYearOptions, getSelectedTaxYear, includeSelectedTaxYearOption } from "./common/taxSelection";
import { getDataApi1, loadApi, saveApi , loadApi1, saveApi1, delApi1} from "../services/appApi";
import axios from "axios";
import numeral from "numeral";
import moment from "moment";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const TaxReturns  = () => {

  let emptyRow = {
    actual_agi: null,
    actual_tax: null,
    actual_tax_filing_date: null,
    amendment_number: null,
    business_dba_name: null,
    business_email_address: null,
    business_federal_tax_id: null,
    business_legal_name: null,
    business_phone_number: null,
    calculated_agi: null,
    calculated_tax: null,
    calculated_taxable_income: null,
    calculated_total_income: null,
    client_contact_cell_phone: null,
    client_contact_email_address: null,
    client_contact_home_phone: null,
    client_contact_work_phone: null,
    client_federal_tax_id: null,
    client_federal_tax_id_type: "",
    client_first_name: "",
    client_id: null,
    client_last_name: null,
    client_middle_name: null,
    client_tax_return_id: null,
    client_type_desc: null,
    client_type_lkcd: "",
    client_type_mean: null,
    created_by: null,
    creation_date: "",
    description: null,
    documents_receipt_date: null,
    firm_id: null,
    important_notes: null,
    last_update_date: "",
    last_updated_by: null,
    spouse_contact_cell_phone: null,
    spouse_contact_email_address: null,
    spouse_contact_home_phone: null,
    spouse_contact_work_phone: null,
    spouse_federal_tax_id: null,
    spouse_federal_tax_id_type: "",
    spouse_first_name: null,
    spouse_last_name: null,
    spouse_middle_name: null,
    tax_filing_status_desc: null,
    tax_filing_status_lkcd: null,
    tax_filing_status_mean: null,
    tax_year: null,
    tax_year_description: ""
    };
  const emptyDtlRow = {
    amendment_number: null,
    amount: null,
    amount_source: "",
    business_dba_name: null,
    business_email_address: null,
    business_federal_tax_id: null,
    business_legal_name: null,
    business_phone_number: null,
    client_contact_cell_phone: null,
    client_contact_email_address: null,
    client_contact_home_phone: null,
    client_contact_work_phone: null,
    client_federal_tax_id: null,
    client_federal_tax_id_type: "",
    client_first_name: "",
    client_id: null,
    client_last_name: null,
    client_middle_name: null,
    client_tax_return_id: null,
    client_type_desc: null,
    client_type_lkcd: "",
    client_type_mean: null,
    firm_id: null,
    sort_seq: null,
    spouse_contact_cell_phone: null,
    spouse_contact_email_address: null,
    spouse_contact_home_phone: null,
    spouse_contact_work_phone: null,
    spouse_federal_tax_id: null,
    spouse_federal_tax_id_type: "",
    spouse_first_name: null,
    spouse_last_name: null,
    spouse_middle_name: null,
    tax_line_lkcd: "",
    tax_line_number: null,
    tax_year: null
  }

  const [rows, setRows] = useState([]);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [showProductDtlDialog, setShowProductDtlDialog] = useState(false);
  const [row, setRow] = useState(emptyRow);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [globalFilter1, setGlobalFilter1] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoading1, setIsLoading1] = useState(false);
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [expandedRowId, setExpandedRowId] = useState([]);
  const [client1040LinesSum, setClient1040LinesSum] = useState({});
  const [dtlRow, setDtlRow] = useState(emptyDtlRow);
  const [loadingRowId, setLoadingRowId] = useState(null);
  const [filters, setFilters] = useState({
      client_first_name: {value: null, matchMode: FilterMatchMode.IN,},
      tax_year: {value: null, matchMode: FilterMatchMode.IN,}
    });
  const [apiErrorDialog, setApiErrorDialog] = useState(sessionStorage.getItem("taxSessionExpired") === "true");
  const toast = useRef(null);
  const dt = useRef(null);
  const dt1 = useRef(null);
  const fetchStarted = useRef(false);
  const prevExpanRef = useRef([]);
  const [currentMode, setCurrentMode] = useState(''); 
  const [clientNameOptions, setClientNameOptions] = useState([]);
  const [taxYearDropdownOptions, setTaxYearDropdownOptions] = useState([]);
  const [fetchClientFlag, setFetchClientFlag] = useState(false);
  const [deleteRowDialog, setDeleteRowDialog] = useState(false);
  const userId = localStorage.getItem("taxUserId");
  const selectedClientId = localStorage.getItem("taxSelectedClientId");
  const selectedTaxYear = localStorage.getItem("taxSelectedTaxYear") || null;
  const firmId = localStorage.getItem("taxFirmId");
  const getNewRow = () => ({ ...emptyRow, client_id: selectedClientId, client_first_name: localStorage.getItem("taxSelectedClientName") || "", tax_year: getSelectedTaxYear() });

  useEffect(() => {
    fetchTaxYearOptions().then(setTaxYearDropdownOptions).catch(() => setTaxYearDropdownOptions([]));
  }, []);

    const fetchRows = async () => {
      try {
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
        const response = await getDataApi1(`/ztx_client_tax_returns_v/v1/?p_client_id=${encodeURIComponent(selectedClientId)}&p_user_id=${encodeURIComponent(userId || "")}&p_tax_year=${encodeURIComponent(selectedTaxYear ?? "")}&offset=${offset}&limit=${limit}`, );
        allData = [...allData, ...response.data.o_return_data_rc];
        status =  response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
        }
        if (status == 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            setRows(allData);
            setIsLoading(false);
          } else {
            //setRows(null);
            setRows([]);
            setIsLoading(false);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          const errorInfo = "Error";

            // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name== 'CanceledError') {
        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
            // Set the error message and display the dialog
            setIsLoading(false);
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
      }
    }
    };

    useEffect(() => {
                      const fetchClient = async () => {
                        setFetchClientFlag(true);
                        try {
                          let offset = 0;
                          let limit = 25;
                          let hasMore = true;
                          let allData = [];
                          let status = null;
                          while (hasMore) {
                            const response = await getDataApi1(
                               `/ztx_firm_clients_v/v1/?p_user_id=${encodeURIComponent(userId || "")}&p_firm_id=${encodeURIComponent(firmId || "")}&offset=${offset}&limit=${limit}`,
                    );
                            allData = [...allData, ...response.data.o_return_data_rc];
                            status = response.status;
                            hasMore = response.data.hasMore;
                            offset = offset + limit;
                          }
                          if (allData.length > 0) {
                            const options = allData.map((item) => ({
                              label: item.client_first_name,
                              value: String(item.client_id),
                            }));
                            setClientNameOptions(options);
                            console.log(options);
                            setFetchClientFlag(false);
                          }
                        } catch (err) {
                          console.error(err);
                          setFetchClientFlag(false);
                        }
                      };
                      fetchClient();
                    }, []);
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);

  const numCalcTotIncTemplate = (rowData) => {
    return (rowData.calculated_total_income || rowData.calculated_total_income === 0) ? numeral(rowData.calculated_total_income).format('0,0.00') : null;
  };
  const numCalcAGITemplate = (rowData) => {
    return (rowData.calculated_agi || rowData.calculated_agi === 0) ? numeral(rowData.calculated_agi).format('0,0.00') : null;
  };
  const numCalcTaxIncTemplate = (rowData) => {
    return (rowData.calculated_taxable_income || rowData.calculated_taxable_income === 0) ? numeral(rowData.calculated_taxable_income).format('0,0.00') : null;
  };
  const numCalcTaxTemplate = (rowData) => {
    return (rowData.calculated_tax || rowData.calculated_tax === 0) ? numeral(rowData.calculated_tax).format('0,0.00') : null;
  };
  const numActAGITemplate = (rowData) => {
    return (rowData.actual_agi || rowData.actual_agi === 0) ? numeral(rowData.actual_agi).format('0,0.00') : null;
  };
  const numActTaxTemplate = (rowData) => {
    return (rowData.actual_tax || rowData.actual_tax === 0) ? numeral(rowData.actual_tax).format('0,0.00') : null;
  };
  const docReiptDateTemplate = (rowData) => {
    return rowData.documents_receipt_date ? moment.utc(rowData.documents_receipt_date).format("YYYY-MM-DD") : null;
  };
  const actFileDateTemplate = (rowData) => {
    return rowData.actual_tax_filing_date  ? moment.utc(rowData.actual_tax_filing_date).format("YYYY-MM-DD") : null;
  };
  const numTaxLineTemplate = (rowData) => {
    return (rowData.tax_line_number || rowData.tax_line_number === 0) ? numeral(rowData.tax_line_number).format('0,0') : null;
  };
  const numSortSeqTemplate = (rowData) => {
    return (rowData.sort_seq || rowData.sort_seq === 0) ? numeral(rowData.sort_seq).format('0,0') : null;
  };
  const numAmountTemplate = (rowData) => {
    return (rowData.amount || rowData.amount === 0) ? numeral(rowData.amount).format('0,0.00') : null;
  };

  const numCalcTotInc = (row.calculated_total_income || row.calculated_total_income === 0) ? numeral(row.calculated_total_income).format('0,0.00') : null;
  const numCalcAGI = (row.calculated_agi || row.calculated_agi === 0) ? numeral(row.calculated_agi).format('0,0.00') : null;
  const numCalcTaxInc = (row.calculated_taxable_income || row.calculated_taxable_income === 0) ? numeral(row.calculated_taxable_income).format('0,0.00') : null;
  const numCalcTax = (row.calculated_tax || row.calculated_tax === 0) ? numeral(row.calculated_tax).format('0,0.00') : null;
  const numActAGI = (row.actual_agi || row.actual_agi === 0) ? numeral(row.actual_agi).format('0,0.00') : null;
  const numActTax = (row.actual_tax || row.actual_tax === 0) ? numeral(row.actual_tax).format('0,0.00') : null;
  const docReiptDate = row.documents_receipt_date ? moment.utc(row.documents_receipt_date).format("YYYY-MM-DD") : null;
  const actFileDate = row.actual_tax_filing_date ? moment.utc(row.actual_tax_filing_date).format("YYYY-MM-DD") : null;
  const numTaxLine = (dtlRow.tax_line_number || dtlRow.tax_line_number === 0) ? numeral(dtlRow.tax_line_number).format('0,0') : null;
  const numSortSeq = (dtlRow.sort_seq || dtlRow.sort_seq === 0) ? numeral(dtlRow.sort_seq).format('0,0') : null;
  const numAmount = (dtlRow.amount || dtlRow.amount === 0) ? numeral(dtlRow.amount).format('0,0.00') : null;

  const hideDialog = () => {
    setShowProductDialog(false);
    setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };
  const showNewProduct = () => {
    setRow(getNewRow());
    setCurrentMode('I');
    setShowProductDialog(true);
  };

  const showProduct = (row) => {
    setRow({ ...row });
    setCurrentMode('R');
    setShowProductDialog(true);
}

const showEditProduct = (row) => {
    setRow({ ...row }); 
    setCurrentMode('U');
    setShowProductDialog(true);
  };

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">TaxReturns Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      TaxReturns
                      </h2>
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      />
                    </span>
                        </div>
                      </h2>
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <Button
        // label="New"
        icon="pi pi-plus"
        className="p-button-success p-button-rounded p-mr-2"
        onClick={showNewProduct}
        tooltip="New"
        tooltipOptions={{ position: "bottom" }}
      />
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );

  const showDtlProduct = (dtlRow) => {
    setDtlRow({ ...dtlRow });
    setShowProductDtlDialog(true);
  }

  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

   const editBodyTemplate = (rowData) => {
          return (
            <React.Fragment>
              <Button
                icon="pi pi-pencil"
                className="p-button-rounded p-button-secondary"
                onClick={() => showEditProduct(rowData)}
                tooltip="Edit"
                tooltipOptions={{ position: "bottom" }}
              />
            </React.Fragment>
          );
      };

  const dtlReadBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showDtlProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };
  const getOraDateFormat24 = (dateValue) => {
    return dateValue ? moment.utc(dateValue).format("YYYY-MM-DDTHH:mm:ss[Z]") : null;
  };

  const clientOptions = [...new Set(rows.map((item) =>  item.client_first_name).filter(Boolean)),].map((client_first_name) => ({
    label: client_first_name, value: client_first_name,
  }));

  const taxYearOptions = [...new Set(rows.map((item) =>  item.tax_year).filter(Boolean)),].map((tax_year) => ({
    label: tax_year, value: tax_year,
  }));

  const clientFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={clientOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select Client"
    display="chip" showClear/>
  )

  const taxYearFilterTemplate = (options) => (
    <MultiSelect value={options.value || []} options={taxYearOptions} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select"
    display="chip" showClear/>
  )
  
  const fetchClient1040LinesSum = async (client_tax_return_id) => {
    setIsLoading1(true);
    setLoadingRowId(client_tax_return_id);
    try {
      let offset = 0;
      let limit = 25;
      let hasMore = true;
      let allData1 = [];
      let status = null;
      while (hasMore) {
      const response = await getDataApi1(
        `/ztx_client_1040_lines_sum_v/?offset=${offset}&limit=${limit}&q={"client_tax_return_id":${client_tax_return_id}}`
      );
        allData1 = [...allData1, ...response.data.items];
        status =  response.status;
        hasMore = response.data.hasMore;
        offset = offset + limit;
    }

      if (allData1.length > 0) {
          setClient1040LinesSum((prevClient1040LinesSum) => ({
            ...prevClient1040LinesSum,
            [client_tax_return_id]: allData1,
          }));
          setIsLoading1(false);
      } else {
        setClient1040LinesSum((prevClient1040LinesSum) => ({ ...prevClient1040LinesSum, [client_tax_return_id]: [] }));
        setIsLoading1(false);
      }
    } catch (error) {
      setErrorMessage(error.message);
      setErrorDialogVisible(true);
    } finally {
      setIsLoading1(false);
      setLoadingRowId(null);
    }
  };

  useEffect(() => {
    const prevExpanded = prevExpanRef.current;
      const newlyExpanded = expandedRowId.filter((id) => !prevExpanded.includes(id))
      newlyExpanded.forEach((client_tax_return_id) => {
      if(client_tax_return_id) {
        fetchClient1040LinesSum(client_tax_return_id);
      }
    });
    prevExpanRef.current = expandedRowId;
  }, [expandedRowId])
 

  const drillDownTemplate = (rowData) => {
    const isExpanded = expandedRowId.includes(rowData.client_tax_return_id);

    return (
      <Button
        icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
        className={`p-button-rounded p-button-sm ${
          isExpanded ? "p-button-danger" : "p-button-primary"
        }`}
        onClick={() => toggleRowExpansion(rowData.client_tax_return_id)}
        tooltip="Detail"
        tooltipOptions={{ position: "bottom" }}
        style={{ fontSize: "1rem" }}
      />
    );
  };

  const toggleRowExpansion = (rowId) => {
    setExpandedRowId((prevExpandedRowId) =>
      prevExpandedRowId.includes(rowId)
        ? prevExpandedRowId.filter((id) => id !== rowId)
        : [...prevExpandedRowId, rowId]
    );
  };

   const saveData = async (currentMode) => {
      if(currentMode === 'I') {
      try {
        const p_param = {
            p_user_id: userId,                                                             
            p_client_id: row.client_id,                                                                 
            p_tax_year: row.tax_year,                                                                   
            p_tax_filing_status_lkcd: row.tax_filing_status_lkcd,                                       
            p_amendment_number: row.amendment_number,                                                   
            p_actual_agi: row.actual_agi,                                                               
            p_actual_tax: row.actual_tax,             
            p_documents_receipt_date: row.documents_receipt_date
            ? moment(row.documents_receipt_date)
                .utc()
                .format("YYYY-MM-DDTHH:mm:ss[Z]")
            : null,
            p_actual_tax_filing_date: row.actual_tax_filing_date
              ? moment(row.actual_tax_filing_date)
                  .utc()
                  .format("YYYY-MM-DDTHH:mm:ss[Z]")
              : null,                                      
            p_important_notes: row.important_notes,                                                     
            p_description: row.description, 
        };
        console.log("Insert p_param: ", p_param);
        const response = await loadApi1(
          p_param,
          "/ztx_client_tax_returns/v1/",
        );
        console.log(response);
        console.log(response.data);
        if (response.data.o_success_flag === "Y") {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Data Inserted",
          });
          const newRow = {
            ...row,
            client_tax_return_id: response.data.o_client_tax_return_id,
          };
          setRows((prev) => [...prev, newRow]);
          setShowProductDialog(false);
          setCurrentMode('');
          setRow(emptyRow);
        } else {
          const err_msg = response.data.o_return_msg;
          toast.current.show({
            severity: "error",
            summary: err_msg,
            detail: "Data Not Inserted",
            life: 3000,
            width: "600px",
          });
          setErrorMessage(err_msg);
          setErrorDialogVisible(true);
        }
      } catch (error) {
        if (axios.isCancel(error) || error.name == "CanceledError") {
          toast.current.show({
            severity: "warn",
            summary: "Cancelled",
            detail: "Request successfully cancelled by the user.",
            life: 3000,
          });
        } else {
          // Set the error message and display the dialog
          setErrorMessage(error.message);
          setErrorDialogVisible(true);
        }
      }
    } else if (currentMode === 'U'){
  
       const p_param = {                                                                              
            p_user_id: userId,                                                                                  
            p_client_tax_return_id: row.client_tax_return_id,                                           
            p_client_id: row.client_id,                                                                 
            p_tax_year: row.tax_year,                                                                   
            p_tax_filing_status_lkcd: row.tax_filing_status_lkcd,                                       
            p_amendment_number: row.amendment_number,                                                   
            p_actual_agi: row.actual_agi,                                                               
            p_actual_tax: row.actual_tax,            
            p_documents_receipt_date: getOraDateFormat24(row.documents_receipt_date),                 
            p_actual_tax_filing_date: getOraDateFormat24(row.actual_tax_filing_date),                                         
            p_important_notes: row.important_notes,                                                     
            p_description: row.description,                                                                       
      
       };    
     
      console.log("Edit p_param: ", p_param);
      try {
        const response = await saveApi1(
          p_param,
          `/ztx_client_tax_returns/v1/`,
        );
        console.log(response);
        if (response.data.o_success_flag === "Y") {
          toast.current.show({
            severity: "success",
            summary: "Success",
            detail: "Data Updated",
          });
          setRows((prev) =>
            prev.map((data) =>
              data.client_tax_return_id === row.client_tax_return_id
                ? { ...row }
                : data,
            ),
          );
          setShowProductDialog(false);
          setCurrentMode('');
        } else {
          const err_msg = response.data.o_return_msg;
          toast.current.show({
            severity: "error",
            summary: err_msg,
            detail: "Data Not Updated",
            life: 3000,
            width: "600px",
          });
          setErrorMessage(err_msg);
        }
  
        //setRows(response.data);
      } catch (error) {
        if (axios.isCancel(error) || error.name == "CanceledError") {
          toast.current.show({
            severity: "warn",
            summary: "Cancelled",
            detail: "Request successfully cancelled by the user.",
            life: 3000,
          });
        } else {
          // Set the error message and display the dialog
          setErrorMessage(error.message);
          setErrorDialogVisible(true);
        }
      }
    }
    };

    const hideDeleteRowDialog = () => {
      setDeleteRowDialog(false);
    };

    const confirmDeleteRow = (row) => {
      setRow(row);
      setDeleteRowDialog(true);
    };

    const deleteRow = async () => {
      const p_param = {
        p_user_id: userId,
        p_client_tax_return_id: row.client_tax_return_id,
        p_client_id: row.client_id,
      };
      try {
        const response = await delApi1(
          { params: p_param },
          "/ztx_client_tax_returns/v1/",
        );
        let successFlag = response.data.o_success_flag;
        if (successFlag === "Y") {
          let _rows = rows.filter((val) => val.client_tax_return_id !== row.client_tax_return_id);
          setRows(_rows);
          setDeleteRowDialog(false);
          setRow(emptyRow);
          toast.current.show({
            severity: "success",
            summary: "Successful",
            detail: "Record Deleted",
            life: 3000,
            width: "600px",
          });
        } else {
          let err_msg = response.data.o_return_msg;
          toast.current.show({
            severity: "error",
            summary: err_msg,
            detail: "Record Not Deleted",
            life: 3000,
            width: "600px",
          });
        }
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Deletion Failed",
          life: 3000,
          width: "600px",
        });
      }
    };

    const deleteRowDialogFooter = (
      <React.Fragment>
        <Button
          label="No"
          icon="pi pi-times"
          severity="secondary"
          onClick={hideDeleteRowDialog}
        />
        <Button label="Yes" icon="pi pi-check" onClick={deleteRow} />
      </React.Fragment>
    );

    const actionBodyDeleteTemplate = (rowData) => {
      return (
        <React.Fragment>
          <Button
            icon="pi pi-trash"
            className="p-button-rounded p-button-warning"
            onClick={() => confirmDeleteRow(rowData)}
            tooltip="Delete"
            tooltipOptions={{ position: "bottom" }}
          />
        </React.Fragment>
      );
    };

  const rowExpansionTemplate = (data) => {
    const client1040LinesSumData = client1040LinesSum[data.client_tax_return_id] || [];
    const exportCSV1 = () => {
      dt1.current.exportCSV();
    };

    return (
      <div className="p-3">
        {loadingRowId == data.client_tax_return_id && (<h4>The data is loading...</h4>)}
        {loadingRowId != data.client_tax_return_id && (<>
        <div className="header-container">
          <div className="header-container p-1">
            <style>
              {`
                input::placeholder {
                  font-size: 17px;
                }
              `}
            </style>
            <span className="p-input-icon-right w-full md:w-auto">
              <InputText
                type="search"
                onInput={(e) => setGlobalFilter1(e.target.value)}
                placeholder="Search..."
                className="w-full lg:w-auto text-sm p-3"
                style={{ fontSize: "17px" }}
              />
            </span>
            <Button
              icon="pi pi-upload"
              className="p-button-primary p-button-rounded"
              onClick={exportCSV1}
              tooltip="Export"
              tooltipOptions={{ position: "bottom" }}
              style={{ marginLeft: "20px", marginBottom: "10px" }}
            />
            <span style={{marginLeft: "20px"}}>
              <b>No. of Rows :</b> {client1040LinesSumData.length}
            </span>
          </div>
        </div>
        <DataTable
          ref={dt1}
          value={client1040LinesSumData}
          style={{ maxWidth: '1150px' }}
          dataKey={client1040LinesSumData.business_federal_tax_id}
          responsiveLayout="scroll"
          globalFilter={globalFilter1}
          sortMode="multiple"
          multiSortMeta={[{field: "client_first_name", order: 1},
                          {field: "tax_year", order: 1},
                          {field: "tax_line_number", order: 1},
                          {field: "sort_seq", order: 1},
                          {field: "amount_source", order: 1},
          ]}

        >
          <Column body={dtlReadBodyTemplate} headerStyle={{background: "#d3d3d3"}} bodyStyle={{background: "#f5f5f5"}} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column field="client_first_name" header="Client" headerStyle={{background: "#d3d3d3"}} bodyStyle={{background: "#f5f5f5"}} sortable></Column>
          <Column field="tax_year" header="Tax Year" bodyStyle={{ textAlign: "right", background: "#f5f5f5" }} headerStyle={{background: "#d3d3d3"}}  sortable></Column>
          <Column field="tax_line_number" header="TaxLine#" body={numTaxLineTemplate} headerStyle={{background: "#d3d3d3"}} bodyStyle={{ textAlign: "right", background: "#f5f5f5"}} sortable></Column>
          <Column field="sort_seq" header="SortSeq" body={numSortSeqTemplate} headerStyle={{background: "#d3d3d3"}} bodyStyle={{ textAlign: "right", background: "#f5f5f5" }} sortable></Column>
          <Column field="amount_source" header="AmountSource" headerStyle={{background: "#d3d3d3"}} bodyStyle={{background: "#f5f5f5"}} sortable></Column>
          <Column field="amount" header="Amount" body={numAmountTemplate} headerStyle={{background: "#d3d3d3"}} bodyStyle={{ textAlign: "right", background: "#f5f5f5" }} sortable></Column>
        </DataTable>
        </>
        )}
      </div>
    );
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4">TaxReturns</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="client_tax_return_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={taxPageRows}
          rowsPerPageOptions={taxRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort
          filters={filters}
          filterDisplay="row"
          onFilter={(e) => setFilters(e.filters)}
          expandedRows={expandedRowId.map((client_tax_return_id) =>
                rows.find((rows) => rows.client_tax_return_id === client_tax_return_id)
              )}
              onRowToggle={(e) => {
                const rowId = e.data ? e.data.client_tax_return_id : null;
                setExpandedRowId((prev) =>
                  prev.includes(rowId)
                    ? prev.filter((client_tax_return_id) => client_tax_return_id !== rowId)
                    : [...prev, rowId]
                );
              }}
          rowExpansionTemplate={rowExpansionTemplate}
        >         
          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={editBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column>
          <Column body={actionBodyDeleteTemplate} style={{ width: "0.75rem" }} ></Column>
          <Column body={drillDownTemplate} style={{ width: "3rem", textAlign: "center" }}/>
          {/* <Column field="client_first_name" header="Client" sortable filter showFilterMenu={false} filterMenuStyle={{ width: '14rem' }} filterElement={clientFilterTemplate}></Column>
          <Column field="tax_year" header="Tax Year" filter showFilterMenu={false} filterElement={taxYearFilterTemplate}  bodyStyle={{textAlign: "right"}} sortable></Column> */}
          <Column field="tax_filing_status_mean" header="Status" sortable></Column>
          <Column field="calculated_total_income" header="CalcTotInc" body={numCalcTotIncTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="calculated_agi" header="CalcAGI" body={numCalcAGITemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="calculated_taxable_income" header="CalcTaxInc" body={numCalcTaxIncTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="calculated_tax" header="CalcTax" body={numCalcTaxTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="actual_agi" header="ActAGI" body={numActAGITemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="actual_tax" header="ActTax" body={numActTaxTemplate} bodyStyle={{textAlign: "right"}} sortable></Column>
          <Column field="documents_receipt_date" header="DocReiptDate" body={docReiptDateTemplate} sortable></Column>
          <Column field="actual_tax_filing_date" header="ActFileDate" body={actFileDateTemplate} sortable></Column>
          <Column field="important_notes" header="ImpNotes" sortable></Column>
        </DataTable>
      </div>
      )}

      {/* <Dialog visible={showproductDialog} style={{ width: '37.5rem' }} header="TaxReturns" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="client_first_name">Client</label>
                    <div className="box">
                        {row.client_first_name}
                    </div>

                <label htmlFor="tax_year">Tax Year</label>
                    <div className="box">
                        {row.tax_year}
                    </div>

                <label htmlFor="tax_filing_status_mean">Status</label>
                    <div className="box">
                        {row.tax_filing_status_mean}
                    </div>

                <label htmlFor="calculated_total_income">CalcTotInc</label>
                    <div className="box">
                        {numCalcTotInc}
                    </div>
                <label htmlFor="calculated_agi">CalcAGI</label>
                    <div className="box">
                        {numCalcAGI}
                    </div>

                <label htmlFor="calculated_taxable_income">CalcTaxInc</label>
                    <div className="box">
                        {numCalcTaxInc}
                    </div>

                <label htmlFor="calculated_tax">CalcTax</label>
                    <div className="box">
                        {numCalcTax}
                    </div>

                <label htmlFor="actual_agi">ActAGI</label>
                    <div className="box">
                        {numActAGI}
                    </div>
                <label htmlFor="actual_tax">ActTax</label>
                    <div className="box">
                        {numActTax}
                    </div>

                <label htmlFor="documents_receipt_date">DocReiptDate</label>
                    <div className="box">
                        {docReiptDate}
                    </div>

                <label htmlFor="actual_tax_filing_date">ActFileDate</label>
                    <div className="box">
                        {actFileDate}
                    </div>

                <label htmlFor="important_notes">ImpNotes</label>
                    <div className="box">
                        {row.important_notes}
                    </div>

            </Dialog> */}
            <Dialog visible={showProductDtlDialog} style={{ width: '37.5rem' }} header="Firm Clients" modal className="p-fluid" onHide={hideDialog}>
                
                <label htmlFor="client_first_name">Client</label>
                    <div className="box">
                        {dtlRow.client_first_name}
                    </div>
                 <label htmlFor="tax_year">Tax Year</label>
                    <div className="box">
                        {dtlRow.tax_year}
                    </div>
                   <label htmlFor="tax_line_number">TaxLine#</label>
                    <div className="box">
                        {numTaxLine}
                    </div>
                     <label htmlFor="sort_seq">SortSeq</label>
                    <div className="box">
                        {numSortSeq}
                    </div>
                    <label htmlFor="amount_source">AmountSource</label>
                    <div className="box">
                        {dtlRow.amount_source}
                    </div>
                    <label htmlFor="amount">Amount</label>
                    <div className="box">
                        {numAmount}
                    </div>
            </Dialog>
            <Dialog
              // header="Add TaxReturns"
              header={currentMode === 'I' ? "Add TaxReturns" : currentMode === 'U' ? "Update TaxReturns" : currentMode === 'R' ? "View TaxReturns" : " TaxReturns"}
              visible={showproductDialog}
              style={{ width: "40rem" }}
              onHide={() => setShowProductDialog(false)}
            >
              <div className="p-fluid">
                <div className="grid">
                  <div className="col-12    field">
                    <label>Client</label>
                    <Dropdown
                      value={row.client_id ? String(row.client_id) : null}
                      disabled
                      options={clientNameOptions}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select Client"
                      onChange={(e) => {
                        const selectedOption = clientNameOptions.find(
                          (option) => option.value === e.value,
                        );
                        setRow({
                          ...row,
                          client_id: e.value,
                          client_first_name: selectedOption?.label || "",
                        });
                      }}
                    />
                  </div>
                  <div className="col-12    field">
                    <label>Tax Year</label>
                    <Dropdown
                      value={row.tax_year ? String(row.tax_year) : null}
                      disabled
                      options={includeSelectedTaxYearOption(taxYearDropdownOptions)}
                      optionLabel="label"
                      optionValue="value"
                      placeholder="Select Tax Year"
                      filter
                    />
                  </div>
                  <div className="col-12    field">
                    <label>Tax Filing Status</label>
                    <InputText
                      value={row.tax_filing_status_lkcd}
                      disabled = {currentMode === 'R' ? true : false}
                      onChange={(e) => setRow({ ...row, tax_filing_status_lkcd: e.target.value })}
                    />
                  </div>

                  <div className="col-12  md:col-6  field">
                    <label>Amendment Number</label>
                    <InputNumber
                      value={row.amendment_number}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={false}
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onChange={(e) => setRow({ ...row, amendment_number: e.value })}
                    />
                  </div>
                  <div className="col-12  md:col-6  field">
                    <label>Actual Agi</label>
                    <InputNumber
                      value={row.actual_agi}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={false}
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onValueChange={(e) => setRow({ ...row, actual_agi: e.value })}
                    />
                  </div>
                  <div className="col-12  md:col-6  field">
                    <label>Actual Tax</label>
                    <InputNumber
                      value={row.actual_tax}
                      disabled = {currentMode === 'R' ? true : false}
                      useGrouping={false}
                      maxFractionDigits={2}
                      inputStyle={{ textAlign: 'right' }}
                      onValueChange={(e) => setRow({ ...row, actual_tax: e.value })}
                    />
                  </div>
                  <div className="col-12  md:col-6  field">
                      <label>Documents Receipt Date</label>
                      <Calendar
                        value={row.documents_receipt_date ? new Date(row.documents_receipt_date) : null}
                        disabled = {currentMode === 'R' ? true : false}
                        dateFormat="yy-mm-dd"
                        showIcon
                        onChange={(e) =>
                          setRow({ ...row, documents_receipt_date: e.value })
                        }
                      />
                  </div>

                  <div className="col-12  md:col-6  field">
                      <label>Tax Filing date</label>
                      <Calendar
                        value={row.actual_tax_filing_date ? new Date(row.actual_tax_filing_date) : null}
                        disabled = {currentMode === 'R' ? true : false}
                        dateFormat="yy-mm-dd"
                        showIcon
                        onChange={(e) =>
                          setRow({ ...row, actual_tax_filing_date: e.value })
                        }
                      />
                  </div>
                  
                  <div className="col-12  field">
                    <label>Important Notes</label>
                    <InputTextarea value={row.important_notes} disabled = {currentMode === 'R' ? true : false} 
                      onChange={(e) => setRow({ ...row, important_notes: e.target.value })} rows={5} cols={30}
                    />
                  </div>

                  <div className="col-12  field">
                    <label>Description</label>
                    <InputTextarea value={row.description} disabled = {currentMode === 'R' ? true : false} 
                      onChange={(e) => setRow({ ...row, description: e.target.value })} rows={5} cols={30}
                    />
                  </div>
                </div>
                
                <div
                  style={{
                    marginTop: "1rem",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "0.5rem",
                  }}
                >
                  <Button
                    label="Cancel"
                    icon="pi pi-times"
                    severity="secondary"
                    onClick={() => {
                      setShowProductDialog(false);
                      setRow(emptyRow);
                      setCurrentMode('');
                    }}
                  />
                  <Button label="Save" icon="pi pi-check" onClick={(e) => saveData(currentMode)} />
                </div>
              </div>
            </Dialog>
            <Dialog
              visible={deleteRowDialog}
              style={{ width: "450px" }}
              header="Confirm"
              modal
              footer={deleteRowDialogFooter}
              onHide={hideDeleteRowDialog}
            >
              <div className="confirmation-content">
                <i
                  className="pi pi-exclamation-triangle p-mr-3"
                  style={{ fontSize: "1.25rem", marginRight: "0.5rem" }}
                />
                {row && (
                  <span>
                    Are you sure you want to delete <b>{row.client_first_name || row.client_tax_return_id}</b>?
                  </span>
                )}
              </div>
            </Dialog>
            {!apiErrorDialog && (
            <Dialog 
                header="API Error" 
                visible={errorDialogVisible} 
                style={{width: '25rem'}}
                onHide={hideDialog} 
                footer={
                    <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                }
            >    
             <p>

                    {errorMessage}
                </p>
            </Dialog>
            )}
            </div>
    </div>
  );
};

export default TaxReturns;